module.exports = __webpack_public_path__ + "img/service1.e60ea9e2.jpg";